/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useState, useRef } from 'react';
import { QUIZ } from '../../../constants/endpoints';
import api from '../../../utils/muApi';
import Loader from '../../Common/Loader';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Modal from '../../Common/Modal';
import { createDestinationUrl } from '../../../utils/utils';
import { find, filter } from 'lodash';
import moment from 'moment';
import Result from './Result';
import EndScreen from './EndScreen';
import Quiz from './Quiz';
import * as track from '../../../utils/analytics';
import { QUIZ_MODAL } from '../../../constants/containerConstants';
import { fadeIn } from '../../../utils/animateUtils';
import ContentAccessModal from '../../Common/ContentAccessModal';

const QuizModal = (props) => {
  const {
    t,
    itemid,
    closeModal,
    cardData,
    gridClass,
    container,
    isDestinationPage,
    onClose,
    sitecoreContext,
  } = props;
  const layoutId = sitecoreContext && sitecoreContext.route && sitecoreContext.route.layoutId;
  const [quizData, setQuizData] = useState({ startQuiz: false });
  const { manutds, Title, ContentType, __Published, ContentAccess } = cardData;
  const [quizResponse, setQuizResponse] = useState([]);
  const [status, setStatus] = useState('fetching');
  const [state, setState] = useState({
    noQuizFound: false,
    error: null,
    serverTime: '',
    optionsDetail_info: {},
    templateDetail_info: {},
    attributeData: {},
    quizItems: [],
    renderQuestionIndex: 0,
    message: '',
    showCover: false,
    quizExpired: false,
    quizResult: {},
    quizCompleted: false,
    trackpageView: true,
    analyticsEnable: false,
    quizItemViewed: 1,
    bgItem: null,
    heroItem: null,
    qnaItem: null,
    selectedArr: [],
  });
  let localState = {
    serverTime: '',
    quizResponse: [],
    quizCompleted: false,
    quizItems: [],
    showCover: false,
    message: '',
    quizResult: {},
    renderQuestionIndex: 0,
    quizCompleted: false,
    trackpageView: true,
    analyticsEnable: false,
    quizItemViewed: 1,
    quizExpired: false,
    selectedArr: [],
  };

  const trackCard = (fields, e, type, trackData) => {
    const initialData = track.data(type);
    track.analytics(
      {
        ...initialData,
        ...trackData,
        item_id: itemid,
        tag: manutds && manutds.value && manutds.value.Tags,
        created_datetime: __Published && __Published.value,
        author: manutds && manutds.value && manutds.value.Author,
        destination_url: manutds && manutds.value && manutds.value.DestinationUrl,
      },
      e
    );
  };

  useEffect(() => {
    document.querySelector('body').classList.add('no-scroll');
    if (itemid) {
      fetchQuizData();
    }
    window.addEventListener('orientationchange', orientationHandle, false);
    return () => {
      const dialogElm = document.querySelector('.quiz-modal');
      dialogElm &&
        dialogElm.removeEventListener('keydown', (e) => {
          handleKeyDown(e, {});
        });
      window.removeEventListener('orientationchange', orientationHandle, false);
    };
  }, []);

  const orientationHandle = () => {
    const option = document.querySelector('.question__options__details');
    if (option && option.scrollTop) {
      option.scrollTop = 0;
    }
  };

  const fetchQuizData = () => {
    setQuizData(() => ({
      ...quizData,
      startQuiz: true,
    }));
    const route = `${QUIZ}${encodeURI(itemid && itemid.toUpperCase())}`;
    return api
      .get({ route })
      .then((data) => {
        onSuccess(data);
        setQuizData(() => ({
          ...quizData,
          startQuiz: false,
        }));
        setState(() => ({
          ...state,
          noQuizFound: localState.quizItems.length,
          serverTime: localState.serverTime,
          quizCompleted: localState.quizCompleted,
          quizItems: localState.quizItems,
          showCover: localState.showCover,
          message: localState.message,
          quizResult: localState.quizResult,
          renderQuestionIndex: localState.renderQuestionIndex,
          quizCompleted: localState.quizCompleted,
          trackpageView: localState.trackpageView,
          analyticsEnable: localState.analyticsEnable,
          quizItemViewed: localState.quizItemViewed,
          quizExpired: localState.quizExpired,
        }));
        setQuizResponse(localState.quizResponse);
        setStatus('success');
      })
      .catch((err) => {
        setStatus('error');
        setState(() => ({
          ...state,
          error: err,
          noQuizFound: false,
          message: t && t('APIFailed') ? t('APIFailed') : '',
        }));
      });
  };

  const onSuccess = ({ data }) => {
    processQuizResponseData(data, cardData); //gets all updated data
    /**
     *  checking Quiz is expired or not if expires then show
     *  expired message otherwise setting $scope.quizResponse
     *  that contains all the questions scopes.
     */
    if (localState && localState.serverTime) {
      const isQuizAlreadyTaken = isUserTakenQuiz();
      const isExpired = checkIsExpiredQuiz(localState.serverTime);
      if (isExpired) {
        if (isQuizAlreadyTaken && localState.quizCompleted == true) {
          if (localState.quizItems && localState.quizItems.length > 0) {
            localState.quizResponse = localState.quizItems;
          }
          initAccessibility('quizResult');
        } else {
          localState.showCover = true;
          localState.quizExpired = true;
          localState.message = t && t('QuizExpired') ? t('QuizExpired') : '';
          initAccessibility('quizExpire');
        }
      } else {
        isQuizAlreadyTaken ? (localState.showCover = false) : (localState.showCover = true);

        if (localState.quizItems && localState.quizItems.length > 0) {
          localState.quizResponse = localState.quizItems;
          animateDom();
          if (localState.showCover) {
            initAccessibility('quizCover');
          } else {
            isQuizAlreadyTaken ? initAccessibility('quizResult') : initAccessibility('quizOptions');
          }
        } else {
          localState.showCover = false;
          localState.message = t && t('QuizNotFound') ? t('QuizNotFound') : '';
          initAccessibility('quizExpire');
        }
      }
    }
    trackPageLoadView('cardPageView', localState.quizExpired);
  };

  const trackPageLoadView = (type, isExpired) => {
    if (localState.quizResponse) {
      if (
        type == 'cardPageView' &&
        localState.quizResponse.length != localState.renderQuestionIndex &&
        localState.trackpageView
      ) {
        trackModalPageView(); //Cover card PageView
      } else if (type == 'qnaPageView') {
        if (localState.showCover == false) {
          if (
            localState.quizResponse &&
            localState.quizResponse[localState.renderQuestionIndex] &&
            localState.quizResponse[localState.renderQuestionIndex].question_t
          ) {
            trackModalPageView(localState.quizResponse[localState.renderQuestionIndex].question_t); //Qna Pageview
          } else {
            trackModalPageView(); //Cover card PageView
          }
        }
      }
    } else if (isExpired == true) {
      trackModalPageView(); //For Expired quiz PageView
    }
  };

  const trackModalPageView = (questionTitle) => {
    const quizModalPageView = {};
    try {
      quizModalPageView.collectionTitle = questionTitle ? questionTitle : Title && Title.value;
      quizModalPageView.collectionDestUrl = createDestinationUrl(
        manutds && manutds.value && manutds.value.DestinationUrl
      );
      track.pageView(quizModalPageView, layoutId);
    } catch (e) {
      console.log(e);
    }
  };

  const animateDom = () => {
    let quizIntervalId;
    trackPageLoadView('qnaPageView'); //track page view on every load of Question
    quizIntervalId = setInterval(function () {
      const qnaOptions = document.querySelector('.question__options');
      if (qnaOptions) {
        clearInterval(quizIntervalId);
        const element = document.querySelector('.fadeInFadeOutContainer');
        if (window.document.documentMode) {
          element.style.removeAttribute('filter');
        }
        if (qnaOptions.style && qnaOptions.style.display) {
          qnaOptions.style.display = 'block';
          // handling this for Safari browser -- start
          const radioButtons = qnaOptions.querySelectorAll('input');
          if (radioButtons && radioButtons.length > 0) {
            for (let i = 0; i < radioButtons.length; i++) {
              const spans = qnaOptions.querySelectorAll('.inner-wrap label span');
              if (spans && spans[i]) {
                spans[i].style.background = 'none';
              }
            }
          }
          // handling this for Safari browser --end
        }

        fadeIn(element, {
          duration: 200,
          complete: () => {
            if (qnaOptions) {
              qnaOptions.scrollTop = 0;
              qnaOptions.classList.add('animate');
            }
            // For Accessibility
            if (state.renderQuestionIndex + 1 === quizResponse.length) {
              initAccessibility('quizResult');
            } else {
              initAccessibility('quizOptions');
            }
          },
        });
      }
    }, 500);
  };

  const initAccessibility = (type) => {
    // start code for  accessibility
    const dialogElm = document.querySelector('.quiz-modal');
    if (type === 'quizOptions' || type === 'quizResult') {
      updateFocusableElm(dialogElm, type);
    } else {
      accessibility(dialogElm, type);
    }
  };

  const updateFocusableElm = (dialogEl, type) => {
    let _selfDialog = {};
    _selfDialog.dialogEl = dialogEl;
    let focusElement;
    let lastElm;
    setTimeout(function () {
      if (type === 'quizOptions') {
        const singleChoiceElem =
          document.querySelector('.single-choice') &&
          document.querySelector('.single-choice').querySelectorAll('input[type=radio]');
        const multiChoiceElem =
          document.querySelector('.multi-choice') &&
          document.querySelector('.multi-choice').querySelectorAll('input[type=checkbox]');
        if (singleChoiceElem && singleChoiceElem.length > 0) {
          lastElm = Array.from(singleChoiceElem).pop();
          lastElm = lastElm.getAttribute('class');
          focusElement = singleChoiceElem[0];
        } else if (multiChoiceElem && multiChoiceElem.length > 0) {
          lastElm = Array.from(multiChoiceElem).pop();
          lastElm = lastElm.getAttribute('class');
          focusElement = multiChoiceElem[0];
        }
      } else if (type === 'quizResult') {
        focusElement = document.querySelector('.result__title');
        focusElement && focusElement.setAttribute('tabindex', '0');
        lastElm = 'acc-button';
      }
      let focusableEls = '';
      try {
        focusElement && focusElement.focus();
        focusableEls = _selfDialog.dialogEl.querySelectorAll(
          '.accessibilityCloseModal, .' + lastElm
        );
        if (type === 'quizResult') {
          focusableEls = _selfDialog.dialogEl.querySelectorAll(
            '.accessibilityCloseModal, .share-button, .acc-button, .' + lastElm
          );
          focusElement && focusElement.removeAttribute('tabindex');
        }
        _selfDialog.focusableEls = Array.prototype.slice.call(focusableEls);
        _selfDialog.firstFocusableEl = _selfDialog.focusableEls[0];
        _selfDialog.lastFocusableEl = document.querySelector('.' + lastElm);
      } catch (e) {
        console.log('error in lastFocusableEl', e);
      }
      if (!_selfDialog.focusedElBeforeOpen) {
        _selfDialog.focusedElBeforeOpen = document.activeElement; // need to update for active Quiz landing card
        open(_selfDialog);
      }
    }, 2000);
  };

  const accessibility = (dialogEl, type) => {
    let _selfDialog = {};
    _selfDialog.dialogEl = dialogEl;
    _selfDialog.contentType = type;
    _selfDialog.focusedElBeforeOpen = document.activeElement; // need to update for active Quiz landing card
    setTimeout(function () {
      if (_selfDialog.dialogEl) {
        if (_selfDialog.contentType === 'quizCover') {
          document.querySelector('.accessibilityCloseModal') &&
            document.querySelector('.accessibilityCloseModal').focus();
          const focusableEls = _selfDialog.dialogEl.querySelectorAll(
            '.quiz-modal .accessibilityCloseModal, .showQuizButton'
          );
          _selfDialog.focusableEls = Array.prototype.slice.call(focusableEls);
          _selfDialog.firstFocusableEl = _selfDialog.focusableEls[0];
          _selfDialog.lastFocusableEl = document.querySelector('.showQuizButton');
        } else if (_selfDialog.contentType === 'quizExpire') {
          document.querySelector('.accessibilityCloseModal') &&
            document.querySelector('.accessibilityCloseModal').focus();
          const focusableEls = _selfDialog.dialogEl.querySelectorAll(
            '.accessibilityCloseModal, .sponsor-accessibility'
          );
          _selfDialog.focusableEls = Array.prototype.slice.call(focusableEls);
          _selfDialog.firstFocusableEl = _selfDialog.focusableEls[0];
          if (
            document.querySelector('.sponsor-accessibility') &&
            document.querySelector('.sponsor-accessibility').length > 0
          ) {
            _selfDialog.lastFocusableEl = document.querySelector('.sponsor-accessibility');
          } else {
            _selfDialog.lastFocusableEl = document.querySelector('.accessibilityCloseModal');
          }
        }
        open(_selfDialog);
      }
    }, 2000);
  };

  // Accessibility open
  const open = (_selfDialog) => {
    _selfDialog.dialogEl.addEventListener('keydown', (e) => {
      handleKeyDown(e, _selfDialog);
    });
  };

  // Accessibility close
  const close = (_selfDialog) => {
    if (_selfDialog.focusedElBeforeOpen) {
      _selfDialog.focusedElBeforeOpen.focus();
    }
  };

  // Accessibility handle keydown
  const handleKeyDown = (e, _selfDialog) => {
    const KEY_TAB = 9;

    const handleBackwardTab = () => {
      if (document.activeElement === _selfDialog.firstFocusableEl) {
        e.preventDefault();
        _selfDialog.lastFocusableEl.focus();
      }
    };

    const handleForwardTab = () => {
      if (document.activeElement === _selfDialog.lastFocusableEl) {
        e.preventDefault();
        _selfDialog.firstFocusableEl.focus();
        if (
          document.querySelector('#accResultId') &&
          document.querySelector('#accResultId').length > 0
        ) {
          document.querySelector('#quiz-accordian') &&
            document.querySelector('#quiz-accordian').classList.remove('button-toggle');
          document.querySelector('#resultSec') &&
            document.querySelector('#resultSec').classList.remove('summary-toggle');
          document.querySelector('#accResultId') &&
            document.querySelector('#accResultId').setAttribute('aria-expanded', 'false');
        }
      }
    };

    switch (e.keyCode) {
      case KEY_TAB:
        if (_selfDialog.focusableEls && _selfDialog.focusableEls.length === 1) {
          e.preventDefault();
          break;
        }
        if (e.shiftKey) {
          handleBackwardTab();
        } else {
          handleForwardTab();
        }
        break;
      default:
        break;
    }
  };

  const checkIsExpiredQuiz = (serverTime) => {
    if (cardData && cardData.EndTime && cardData.EndTime.value && localState.serverTime) {
      const isDateExpired = moment(cardData.EndTime.value).isBefore(serverTime);
      if (isDateExpired && cardData.EndTime.value !== '0001-01-01T00:00:00Z') {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const isUserTakenQuiz = () => {
    /**
     * Check the browser localStorage for the given
     * QUIZ-Id. If it's found then get the lastAttmpedQuestionIndex
     * and Call the function showQuestionByIndex() to draw the
     * particular Question directly.
     */
    if (
      typeof Storage !== undefined &&
      localStorage.getItem('userQuiz') != null &&
      localStorage.getItem('userQuiz') != 'undefined'
    ) {
      const userQuizs = JSON.parse(localStorage.getItem('userQuiz'));
      try {
        if (userQuizs && userQuizs.length > 0) {
          const localQuizData = find(userQuizs, (quiz) => {
            return quiz.quizID == itemid;
          });
          if (localQuizData) {
            if (localQuizData.totalQuestion && localQuizData.lastAttmpedQuestionIndex) {
              if (localQuizData.totalQuestion == localQuizData.lastAttmpedQuestionIndex) {
                const quizResult = {};
                quizResult.chartobj = localQuizData.chartobj;
                quizResult.totalCorrectAnswer = localQuizData.totalCorrectAnswer;
                quizResult.totalQuestion = localQuizData.totalQuestion;
                quizResult.optionsInfo = localQuizData.optionsInfo;

                localState.quizResult = quizResult;
                localState.renderQuestionIndex = localQuizData.lastAttmpedQuestionIndex;
                localState.quizCompleted = true;
              } else {
                localState.renderQuestionIndex = localQuizData.lastAttmpedQuestionIndex;
                localState.quizCompleted = false;
              }
              localState.trackpageView = false; // condition to not track cardpageview if it's open from loacalstorageDirectly
              localState.analyticsEnable = true;
              return true;
            }
          }
          return false;
        }
        return false;
      } catch (e) {
        console.log('error in isUserTakenQuiz', e);
      }
    } else {
      return false;
    }
  };

  const processQuizResponseData = (response, cardData) => {
    try {
      if (isValidResponse(response)) {
        localState.quizItems = response.QuizQuestionsResponse.response.docs;
        initQuiz();
      }
    } catch (e) {
      console.log('processQuizResponseData error');
      console.log(e);
    }
  };
  const initQuiz = () => {
    updateOptionsInfo();
  };

  const updateOptionsInfo = () => {
    /**
     * Update the Json with these options like
     * correctAnswerIndex[],isMultiChoice:false,
     * isImageInOptions:false
     **/
    try {
      if (localState.quizItems) {
        for (let i = 0; i < localState.quizItems.length; i++) {
          const optionsDetail_info = {};
          const quizItem = localState.quizItems[i];
          if (quizItem.questionoptions_s && quizItem.questionoptions_s.length > 0) {
            optionsDetail_info.correctAnswerIndex = [];
            optionsDetail_info.isMultiChoice = false;
            optionsDetail_info.isImageInOptions = false;

            filter(quizItem.questionoptions_s, (options, index) => {
              if (options.isCorrectAnswer == true) {
                optionsDetail_info.correctAnswerIndex.push(index);
                if (optionsDetail_info.correctAnswerIndex.length > 1) {
                  optionsDetail_info.isMultiChoice = true;
                }
              }
              if (options.hasOwnProperty('imagecropurl_s')) {
                optionsDetail_info.isImageInOptions = true;
                optionsDetail_info.optionText = options.optionText;
                optionsDetail_info.imagecropurl_s = options.imagecropurl_s;
              }
            });
          }
          localState.quizItems[i].optionsDetail_info = optionsDetail_info;
          updateTemplateInfo(quizItem, i);
        }
      }
    } catch (e) {
      console.log('error in updating options', e);
    }
  };

  const updateTemplateInfo = (quizItem, index) => {
    /**
     * Adding information to show the layout of Quiz
     * Such like BG-Image/BG-Video/Hero-Img/Hero-Video
     * by using Periority rule.
     * If BGimage and BGvideo came we will show BGVideo
     * If Heroimage an HeroVideo came we will show HeroVideo
     */
    try {
      if (quizItem && quizItem.quizvideoandimagedetails_s) {
        const templateDetail_info = {};
        templateDetail_info.isHeroVideo = false;
        templateDetail_info.isHeroImage = false;
        templateDetail_info.isBackgroundVideo = false;
        templateDetail_info.isBackgroundImage = false;

        const heroVideo = Object.prototype.hasOwnProperty.call(
          quizItem.quizvideoandimagedetails_s,
          'heroVideo'
        );
        const heroImage = Object.prototype.hasOwnProperty.call(
          quizItem.quizvideoandimagedetails_s,
          'heroImage'
        );
        const bgVideo = Object.prototype.hasOwnProperty.call(
          quizItem.quizvideoandimagedetails_s,
          'bgVideo'
        );
        const bgImage = Object.prototype.hasOwnProperty.call(
          quizItem.quizvideoandimagedetails_s,
          'bgImage'
        );

        /**
         *  If HeroVideo and HeroImage will came then periority should be Herovideo
         */
        if (heroVideo && heroImage) {
          templateDetail_info.isHeroVideo = true;
          templateDetail_info.heroItem = quizItem.quizvideoandimagedetails_s.heroVideo;
          templateDetail_info.heroItem.coverImage =
            quizItem.quizvideoandimagedetails_s.heroImage.ImageCropUrl;
        } else if (heroVideo) {
          templateDetail_info.isHeroVideo = true;
          templateDetail_info.heroItem = quizItem.quizvideoandimagedetails_s.heroVideo;
        } else if (heroImage) {
          templateDetail_info.isHeroImage = true;
          templateDetail_info.heroItem = quizItem.quizvideoandimagedetails_s.heroImage.ImageCropUrl;
        }
        /**
         *  If BgVideo and bgImage will came then periority should be BgVideo
         */
        if (bgVideo && bgImage) {
          templateDetail_info.isBackgroundVideo = true;
          templateDetail_info.backgroundItem = quizItem.quizvideoandimagedetails_s.bgVideo;
          templateDetail_info.backgroundItem.coverImage =
            quizItem.quizvideoandimagedetails_s.bgImage.ImageCropUrl;
        } else if (bgVideo) {
          templateDetail_info.isBackgroundVideo = true;
          templateDetail_info.backgroundItem = quizItem.quizvideoandimagedetails_s.bgVideo;
        } else if (bgImage) {
          templateDetail_info.isBackgroundImage = true;
          templateDetail_info.backgroundItem =
            quizItem.quizvideoandimagedetails_s.bgImage.ImageCropUrl;
        }
        localState.quizItems[index].templateDetail_info = templateDetail_info;
      }
    } catch (e) {
      console.log('error in updating template', e);
    }
  };

  const isValidResponse = (response) => {
    try {
      if (
        response &&
        response.QuizQuestionsResponse &&
        response.QuizQuestionsResponse.response &&
        response.QuizQuestionsResponse.response.docs &&
        response.QuizQuestionsResponse.response.docs.length > 0
      ) {
        setServerTime(response);
        return true;
      } else {
        setServerTime(response);
        return false;
      }
    } catch (e) {
      console.log('error in validating response', e);
    }
  };

  const setServerTime = (response) => {
    if (response && response.AwsServerUtcTime) {
      localState.serverTime = response.AwsServerUtcTime;
    }
  };

  const getResultAccessibility = () => {
    initAccessibility('quizResult');
  };

  const showQuiz = (evt) => {
    evt.stopPropagation();
    trackPageLoadView('qnaPageView');
    setState(() => ({
      ...state,
      showCover: false,
      analyticsEnable: true,
    }));
  };

  const renderQna = (type) => {
    if (type == 'heroItem') {
      setState(() => ({
        ...state,
        heroItem: quizResponse[state.renderQuestionIndex],
      }));
    } else if (type == 'bgItem') {
      setState(() => ({
        ...state,
        bgItem: quizResponse[state.renderQuestionIndex],
      }));
    } else if (type == 'qna') {
      setState(() => ({
        ...state,
        qnaItem: quizResponse[state.renderQuestionIndex],
      }));
    }
    progressBar(); //show progress bar at top.
    return 'quiz-hero-and-bg-id-' + Math.random().toString(36).substring(7);
  };

  const progressBar = () => {
    if (quizResponse && quizResponse.length > 0) {
      const totalLi = quizResponse.length;
      const percentWidthLi = 100 / totalLi + '%';
      const progressLine = document.querySelectorAll('ul.slick-dots li');
      if (progressLine && progressLine.length > 0) {
        for (let i = 0; i < progressLine.length; i++) {
          progressLine[i].style.width = percentWidthLi;
        }
      }
    }
  };

  const setQuizState = (stateData) => {
    setState(() => ({
      ...state,
      ...stateData,
    }));
  };

  const trackButton = (e, type) => {
    const buttonObj = track.data('quizButton');
    buttonObj.author = manutds && manutds.value.Author;
    buttonObj.destination_url = createDestinationUrl(
      manutds && manutds.value && manutds.value.DestinationUrl
    );
    buttonObj.content_type = ContentType && ContentType.value;
    buttonObj.collectionTitle = Title && Title.value;
    buttonObj.collectionDestUrl = createDestinationUrl(
      manutds && manutds.value && manutds.value.DestinationUrl
    );
    const element = document.querySelector('#quiz-accordian');
    element.classList.contains('button-toggle');
    if (type === 'accordian-btn' && element.classList.contains('button-toggle')) {
      buttonObj.button_name = t('YourAnswers') ? t('YourAnswers') : '';
      track.analytics({ ...buttonObj }, e);
    } else if (type === 'share-btn') {
      buttonObj.button_name = t('ChallengeAFriend') ? t('ChallengeAFriend') : '';
      track.analytics({ ...buttonObj }, e);
    }
  };

  const trackQuiz = (e) => {
    try {
      const quiztrackObj = track.data('quizExit');
      const trackObjquiz = {};
      let content_exit = state.renderQuestionIndex + 1;
      let isresultScreen = false;
      let quizItemViewed = state.quizItemViewed;
      if (
        quizResponse &&
        quizResponse.length > 0 &&
        quizResponse.length === state.renderQuestionIndex
      ) {
        isresultScreen = true;
        if (quizResponse.length + 1 == quizItemViewed) {
          isresultScreen = false; // handled if user has given quiz continuously
          quizItemViewed = state.renderQuestionIndex;
        }
        content_exit = state.renderQuestionIndex;
      } else if (state.showCover) {
        // handled for cover card
        content_exit = 0;
        isresultScreen = true;
      }
      quiztrackObj.item_id = itemid;
      quiztrackObj.author = manutds && manutds.value && manutds.value.Author;
      quiztrackObj.destination_url = manutds && manutds.value && manutds.value.DestinationUrl;
      quiztrackObj.created_datetime = __Published && __Published.value;
      quiztrackObj.content_type = ContentType && ContentType.value;
      quiztrackObj.card_name = Title && Title.value;
      quiztrackObj.tag = manutds && manutds.value && manutds.value.Tags;
      quiztrackObj.content_items = quizResponse ? quizResponse.length : 0;
      quiztrackObj.container_type = QUIZ_MODAL;
      quiztrackObj.content_items_viewed =
        state.analyticsEnable && quiztrackObj.content_items && isresultScreen == false
          ? quizItemViewed
          : 0;
      quiztrackObj.content_exit =
        state.analyticsEnable && quiztrackObj.content_items ? content_exit : 0;
      quiztrackObj.collectionTitle = Title && Title.value;
      quiztrackObj.collectionDestUrl = manutds && manutds.value && manutds.value.DestinationUrl;
      track.analytics({ ...quiztrackObj }, e);
      isresultScreen = false;
    } catch (e) {
      console.log('error in tracking quiz', e);
    }
  };

  const getAnalyticsData = () => {
    const initialData = track.data('card');
    return {
      ...initialData,
      container_type: props.container,
      item_id: itemid,
      content_type: ContentType && ContentType.value,
      tag: manutds && manutds.value && manutds.value.Tags,
      created_datetime: cardData && cardData.__Published && cardData.__Published.value,
      author: manutds && manutds.value && manutds.value.Author,
      destination_url: manutds && manutds.value && manutds.value.DestinationUrl,
    };
  };

  return (
    <Modal
      containerClass="dialog quiz-modal"
      closeModal={closeModal}
      ariaDescribedBy="dialog1_label"
      onClose={(e) => {
        document.querySelector('body').classList.remove('no-scroll');
        trackQuiz(e);
        isDestinationPage && onClose();
      }}
      headerClass={!state.showCover ? 'innerclose' : ''}
    >
      {isDestinationPage && (
        <ContentAccessModal
          ContentAccess={ContentAccess && ContentAccess.value}
          ContentType={ContentType && ContentType.value}
          manutds={manutds}
          className={`quizcard-modal`}
          insideModal={true}
          isDestinationPage={isDestinationPage}
          analyticsObj={getAnalyticsData()}
        />
      )}
      <div className="quizcard-modal">
        <div className="mu-modal__body__container">
          {/* First and expire screen */}
          {state.showCover && (
            <div className="quiz__coverImg">
              <div>
                <EndScreen
                  t={t}
                  data={cardData}
                  itemid={itemid}
                  closeModal={closeModal}
                  showQuiz={showQuiz}
                  gridClass={gridClass}
                  message={state.message}
                  quizExpired={state.quizExpired}
                  trackCard={trackCard}
                  container={container}
                ></EndScreen>
              </div>
            </div>
          )}
          {/* All Qna screen */}
          {!state.showCover &&
            state.renderQuestionIndex != quizResponse.length &&
            quizResponse.length != 0 && (
              <div>
                {state.renderQuestionIndex < quizResponse.length && (
                  <div className="quiz-paging__wrapper" aria-live="polite">
                    <div className="quiz-paging" aria-hidden="true" tabIndex="-1">
                      {state.renderQuestionIndex + 1 + '/' + quizResponse.length}
                    </div>
                    <div className="screenreader">
                      {t('QuizProgress') ? t('QuizProgress') : 'Quiz Progress'}{' '}
                      {state.renderQuestionIndex + 1 + '/' + quizResponse.length}
                    </div>
                    <ul className="slick-dots">
                      {quizResponse.map((item, index) => (
                        <li
                          key={index}
                          className={index <= state.renderQuestionIndex ? 'active' : ''}
                        ></li>
                      ))}
                    </ul>
                  </div>
                )}
                {quizResponse.length > 0 && (
                  <Quiz
                    t={t}
                    data={cardData}
                    itemid={itemid}
                    closeModal={closeModal}
                    gridClass={gridClass}
                    qnaItem={state.qnaItem}
                    heroItem={state.heroItem}
                    bgItem={state.bgItem}
                    renderQuestionIndex={state.renderQuestionIndex}
                    quizItemViewed={state.quizItemViewed}
                    quizResponse={quizResponse}
                    renderQna={renderQna}
                    setQuizState={setQuizState}
                    animateDom={animateDom}
                    trackCard={trackCard}
                    container={container}
                  ></Quiz>
                )}
              </div>
            )}

          {/* summary screen */}
          {state.quizResult &&
            state.quizResult.optionsInfo &&
            state.renderQuestionIndex == quizResponse.length &&
            quizResponse.length != 0 && (
              <div className="result-screen">
                <div>
                  <Result
                    getResultAccessibility={getResultAccessibility}
                    t={t}
                    data={cardData}
                    itemid={itemid}
                    closeModal={closeModal}
                    gridClass={gridClass}
                    quizResult={state.quizResult}
                    quizResponse={quizResponse}
                    renderQna={renderQna}
                    setQuizState={setQuizState}
                    animateDom={animateDom}
                    trackButton={trackButton}
                    container={container}
                  ></Result>
                </div>
              </div>
            )}
          <p className="result-wrapper">{state.message}</p>
          {quizData.startQuiz && status === 'fetching' && <Loader className="loader-container" />}
        </div>
      </div>
    </Modal>
  );
};
export default withSitecoreContext()(withTranslation()(QuizModal));
